import React, { Component } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { getNewChartData, getDatasourceAndDates } from '../../../api';
import $ from "jquery";
import { isFullscreen } from '../utils/Utils';
import { xlsxCustomExport } from '../utils/chartConfig';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

const IMG_URL = process.env.IMG_FULL_URL;

const responsiveRes = 870;
const mobileRes = 500;
class DigitalisationRisksChart extends Component {
    constructor(props){
        super(props);

        let splitName = props.literals['L'+props.chartType[0].splitName];

        let percentage = props.percentage;
        
        this.state = {
            percentage,
            chartConfig: {
                title: {
                    text: "<h2 class='title--card'>" + this.props.literals['L'+props.chartType[0].title] + "</h2>",
                    align: 'left',
                    widthAdjust: -36,
                    style: {
                        zIndex: 1,
                        lineHeight:36
                    }
                },
                credits: {
                    enabled: true ,
                    text: "",
                    href: '',
                    style: {
                        cursor: 'normal'
                    },
                    position: {
                        x: -150,
                        y: 0
                    }
                },
                caption: {
                    text: this.props.literals['L'+props.chartType[0].asterisk]
                },
                colors: ['#f6a400', '#cbe2e3', '#7b7b7d', '#ffe300'],
                chart: {
                    type: 'column',
                    chartID: props.chartType[0].chart,
                    backgroundColor: '#F0F0F0',
                    events: {
                        render: function() {
                            let chart = this;
                            if (!chart.customImage)
                            {
                                chart.customImage = chart.renderer.image(
                                   `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                                   chart.chartWidth - 130,
                                   chart.chartHeight - 37,
                                   130,
                                   37
                                ).add();
                                chart.customImage.attr({
                                   class:'osha-logo'
                                });
                            }
                            else
                            {
                                chart.customImage.attr({
                                    x: chart.chartWidth - 130,
                                    y: chart.chartHeight - 37
                                });
                            }
    
                            if (chart.fullscreen.isOpen) {
                                chart.customImage.css({
                                   display: 'block',
                                });
                                chart.container.className = 'highcharts-container full-screen';                                
                            }
                            else
                            {
                                chart.legend.options.x=0;                                
                                chart.customImage.css({
                                    display: ''
                                });	
                                chart.container.className = 'highcharts-container';
                            }
                        },
                        beforePrint: function() {
                            if (this.userOptions.chart.chartID == "20002")
                            {
                                this.resetParams = [this.chartWidth, this.chartHeight, false];
                                this.setSize(1500, 500, false);
                            }
                        },
                        afterPrint: function() {
                            if (this.resetParams != null && this.resetParams != undefined)
                            {
                                this.setSize.apply(this, this.resetParams);
                                this.hasUserSize = this.oldhasUserSize;
                            }
                        }
                    },
                },
                exporting: {
                    enabled: true,
                    buttons: {
                        contextButton: {
                            menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
                        }
                    },
                    chartOptions:{
                        credits: {
                            enabled: true
                        }
                    },
					scale: 1.5,
					sourceWidth: 1500,
					sourceHeight: 700,
                    menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Value', this.series, this.title.textStr);
                            }
                        }
                    }
                },
                navigation: {
                    buttonOptions: {
                        theme: {
                            fill: 'transparent',
                            states: {
                                hover: {
                                    fill: '#CCC'
                                },
                                select: {
                                    fill: 'transparent'
                                }
                            }
                        }
                    }
                },
                legend: {
                    enabled: this.props.legend ? this.props.legend : null
                },
                yAxis: {
                    max: this.props.yAxisMax ? this.props.yAxisMax : null,
                    gridLineColor: '#FFF',
                    gridLineWidth: 2,
                    startOnTick: true,
                    endOnTick: true,
                    tickInterval: this.props.step ? this.props.step : null,
                    title: {
                        text: ''
                    },
                    labels: {
                        format: percentage === true ? '{value} %' : `{value}`,
                        style: {
                            fontFamily: 'OpenSans-bold',
                            fontWeight: 'normal',
                            fontSize:  '12px',
                            textOverflow: 'none'
                        }
                    },
                    softMin: undefined,
                    softMax: undefined,
                    reversedStacks: false
                },
                xAxis: {
                    lineWidth: 0,
                    labels: {	
                        style: {
                            fontFamily: 'OpenSans-bold',
                            fontWeight: 'normal',
                            fontSize: '12px' ,
                            textOverflow: 'none'
                        }
                    }
                },
                tooltip: {
                    useHTML: true,
					opacity: 1,
					borderColor:"#529FA2",
					backgroundColor: "rgba(255, 255, 255, 1)",
					style: {
						zIndex: 100
					},                    
					formatter: function () {
                        // let chartTitle = this.series.chart.title.textStr;
						let numberOfDecimals = this.series.options.custom.decimalNumbers;
						let percentage = this.series.options.custom.percentage;
                        if( this.series.name != 'Value'){
                            if (props.showAbsoluteValue === true)
                            {
                                return '<ul class="tooltip-item">'+
                                '<li><strong>Country: </strong>'+ this.series.name  +' </li>' +
                                '<li><strong>'+splitName+': </strong>'+ this.x  +' </li>' +
                                '<li><strong class="tooltip-value up">Value: </strong> '+ Highcharts.numberFormat(this.y,numberOfDecimals,',','.') + percentage + '</li>' + 
                                '<li><strong class="tooltip-value up">Absolute value: </strong> '+ Highcharts.numberFormat(this.point.absolute,numberOfDecimals,',','.') + '</li></ul>';
                            }
                            else
                            {
                                return '<ul class="tooltip-item">'+
                                '<li><strong>Country: </strong>'+ this.x  +' </li>' +
                                '<li><strong>'+splitName+': </strong>'+ this.series.name +' </li>' +
                                '<li><strong class="tooltip-value up">Value: </strong> '+ Highcharts.numberFormat(this.y,numberOfDecimals,',','.') + percentage + '</li>' + '</ul>';
                            }
                        } else {
                            return '<ul class="tooltip-item">'+
                            '<li><strong>Country: </strong>'+ this.x  +' </li>' +
                            '<li><strong class="tooltip-value up">Value: </strong> '+ Highcharts.numberFormat(this.y,numberOfDecimals,',','.') + percentage + '</li></ul>';
                        }

					}
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderWidth: 0,
                        groupPadding: 0.15,
                        pointPadding: 0.15,
                        minPointLength: 2
                    },
                    series: {
                        custom: {
                            decimalNumbers: this.props.decimalNumbers,
                            percentage: '%'
                        },
                        states: {
                            hover: {
                                brightness: 0,
                                halo: {
                                    size: 0,
                                    attributes: {
                                        'stroke-width': 0 //to keep default setting
                                    }
                                }
                            }
                        },
                        border: false
                    },
                },
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 550
                        },
                        chartOptions: {
                            xAxis: {
                                labels: {
                                    style: {
                                        fontSize: "10px"
                                    }
                                }
                            }
                        }
                    }]
                }
            },
            isLoading: false,
            illnesses: [],
            selectedTypeChart: this.props.selectedIndicator != undefined ? this.props.selectedIndicator :  this.props.chartType[0].type,
        }
    }

    getLoadData = (chartType) => {
        let chart = [];
        let country2 = this.props.country2;
        let country3 = this.props.country3;

        // TODO: Assign chart getting the correct chartType
        if (chartType.length > 1) {
            chart = chartType.find((chart) => chart.type == this.state.selectedTypeChart);
        } else {
            chart = chartType[0];
            this.setState({ selectedTypeChart: null });
        }

        if(chart.onlyOneCountry) {
            country2 = null;
            country3 = null;
        }
        
        if(this.props.callbackLegend != undefined){
            this.props.callbackLegend(chart.legend);
        }
        this.getCredits(chart.chart);
        let requestFilter = {
            chart: chart.chart,
            indicator: chart.chartIndicator,
            country1: this.props.country1,
            country2,
            country3,
            datasetIndicator1: this.props.dataset,
            sector: chart.sector,
            age: chart.age,
            occupation: chart.occupation,
            indicator2: chart.chartIndicator2,
            size: chart.size
        }
        getNewChartData(requestFilter)
        .then((data) => {
            if(data.resultset != undefined){
                this.setState({ chartConfig: {...this.state.chartConfig, 
                    chart: { ...this.state.chartConfig.chart, chartID: chart.chart },
                    xAxis:{...this.state.chartConfig.xAxis, categories: data.resultset.xAxisCategories}, 
                    series: data.resultset.data ,
                    plotOptions: { ...this.state.chartConfig.plotOptions, series: { ...this.state.chartConfig.plotOptions.series, custom: { ...this.state.chartConfig.plotOptions.series.custom, decimalNumbers: this.props.decimalNumbers}}}
                }} )

                if(this.state.percentage) {
                    this.setState({ chartConfig: {...this.state.chartConfig, 
                        plotOptions: { ...this.state.chartConfig.plotOptions, series: { ...this.state.chartConfig.plotOptions.series, custom: { ...this.state.chartConfig.plotOptions.series.custom, percentage: '%'}}  }
                    }} )
                }
                else{
                    this.setState({ chartConfig: {...this.state.chartConfig, 
                        plotOptions: { ...this.state.chartConfig.plotOptions, series: { ...this.state.chartConfig.plotOptions.series, custom: { ...this.state.chartConfig.plotOptions.series.custom, percentage: ''}}  }
                    }} )
                }

                this.setState({ chartConfig: { 
                    ...this.state.chartConfig,
                    xAxis:{ ...this.state.chartConfig.xAxis,
                        plotLines: [
                        {
                            color: 'black',
                            width: 2,
                            value: 0.5,
                            id: 'break-eu',
                            zIndex:1
                        },
                        {
                            color: 'black',
                            width: 2,
                            value: 27.5,
                            zIndex:1
                        }
                    ]}/*,
                    legend: {
                        enabled: false
                    }*/
                }} )
                
            }
        })
    }

    getCredits = (chart) => {
        getDatasourceAndDates(chart).then((res)=>{
            let text = res;
            this.setState({
                chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
            })
        })
    }

    updateDimension = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;

        if (width > 767) {
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height}
                    }
                });
            } else {
                // Check if the Axis Labels need to be rotated or not
                let rotate = undefined;
                if (this.props.chartType[0].chart == 20002 || this.props.chartType[0].chart == 20004)
                {
                    rotate = -45;
                }
                let chartHeight = 450;
                if (this.props.chartType[0].chart == 20002 || this.props.chartType[0].chart == 20003)
                {
                    chartHeight = 600;
                    if (height < 800)
                    {
                        chartHeight = 575;
                    }
                }
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: chartHeight, type: 'column'},
                        yAxis: {
                            ...this.state.chartConfig.yAxis,
                            labels: {
                                rotation: 0
                            }
                        },
                        xAxis: {
                            labels: {
                                rotation: rotate
                            }
                        }
                    }
                });
            }
        }

        if (width < 990) {
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height}
                    }
                });
            } else {
                if (width < 768) {
                    this.setState({
                        chartConfig: {
                            ...this.state.chartConfig,
                            chart: {...this.state.chartConfig.chart, height: 1024, type: 'bar'},
                            yAxis: {
                                ...this.state.chartConfig.yAxis,
                                labels: {
                                    rotation: -45
                                }
                            }

                        }
                    }) 
                } else {
                    this.setState({
                        chartConfig: {
                            ...this.state.chartConfig,
                            chart: {...this.state.chartConfig.chart, height: 750, type: 'bar'},
                            yAxis: {
                                ...this.state.chartConfig.yAxis,
                                labels: {
                                    rotation: -45
                                }
                            }

                        }
                    })
                }

            }
        }
    }

    componentDidMount() {
        this.getLoadData(this.props.chartType);
        this.updateDimension();
        window.addEventListener('resize', this.updateDimension);
    }
    
    componentDidUpdate(prevProps, prevState) {
        if(prevProps.country1 != this.props.country1 || prevProps.country2 != this.props.country2 || prevProps.country3 != this.props.country3 
            || prevProps.chartType != this.props.chartType || prevState.selectedTypeChart != this.state.selectedTypeChart
            || prevProps.dataset != this.props.dataset)
        {
            this.getLoadData(this.props.chartType);
        }
        if(prevProps.chartType != this.props.chartType) {
            this.setState({ chartConfig: {...this.state.chartConfig, 
                title: {text: "<h2 class='title--card'>" + this.props.literals['L'+this.props.chartType[0].title] + "</h2>"}
            }} )
        }
        window.addEventListener('resize', this.updateDimension);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimension);
    }

    onChangeSelect = (e) => {
        this.setState({ selectedTypeChart: e.target.value });
        this.props.callbackSelectedSurvey(e.target.value);
	}

    render() {
        let selectDatasetDiv;

        if(this.props.selectDatasetDiv){
            selectDatasetDiv = (
                <div className='select-filter-chart'>
                    <select onChange={this.onChangeSelect} value={this.state.selectedTypeChart} >
                        <option key={this.props.chartType[0].type} value={this.props.chartType[0].type} > Absolute value </option>
                        <option key={this.props.chartType[1].type} value={this.props.chartType[1].type} > Percentage value </option>
                    </select>
                </div>
            )
        }
        return(
            <React.Fragment>
                {selectDatasetDiv && ( 
                    <div className='chart--filters--block'>
                        {selectDatasetDiv}
                    </div>
                )}
                <div className='chart-container'>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.state.chartConfig}
                        containerProps={{ className: 'chartContainer' }}
                    />
                </div>
                {/* {customLegend} */}
            </React.Fragment>
        )
    }
}

export default DigitalisationRisksChart;